export enum beerManagerModes {
  listBeers = 'LIST_BEERS',
  addBeers = 'ADD_BEERS',
  manageBeers = 'MANAGE_BEERS',
}

export enum templates {
  Standard = 'Standard',
  Standard2 = 'Standard2',
}
